<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3">
      <v-card-title class="headline justify-space-between">
        <div>
          <v-btn class="mr-3" color="green" dark to="/our_legal_entities/add">
            <v-icon>mdi-plus</v-icon>
            Добавить
          </v-btn>
          <!-- <v-btn class="mr-3" color="green" dark @click="showingDeleted = !showingDeleted">
            <span v-if="!showingDeleted">Показать удаленные</span>
            <span v-else>Скрыть удаленные</span>
          </v-btn> -->
          <v-btn class="mr-3" color="green" :loading="$store.getters.connection" dark @click="$store.dispatch('initOnecStream')">
            Обновить связь 1С
          </v-btn>
          <v-menu v-if="this.$store.getters.user.roleId === 0" class="mr-3" color="green" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                <v-icon>mdi-file-download</v-icon>
                Выгрузить в файл
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportToFile('csv')">csv</v-list-item>
              <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div>
          <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0"
          ></v-text-field>
        </div>
      </v-card-title>

      <v-data-table
        class="mb-3 mx-3"
        :search="search"
        :headers="headers"
        :items="ourLegalEntities"
        :item-class="
          (item) => (item.isDeleted ? 'deleted clickable-row' : 'clickable-row')
        "
        no-data-text="Пусто"
        no-results-text="Результатов нет"
        @click:row="editOurLe"
        hide-default-footer
        :loading="tableLoading"
        loading-text="Загрузка"
        :items-per-page="10"
        sort-by="id"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="!item.isDeleted" top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="deleteOurLeConfirm(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>

          <v-tooltip v-else top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="restoreOurLe(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-backup-restore
              </v-icon>
            </template>
            <span>Восстановить</span>
          </v-tooltip>
        </template>
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
          />
        </template>
        <template v-slot:item.onecConnectionStatus="{ item }">
          <v-progress-circular v-if="!(item.id in $store.getters.onecStates) && item.onecConnection && !item.isDeleted" color="primary" size="20" indeterminate></v-progress-circular>
          <v-tooltip v-else top>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar v-if="item.isDeleted || !item.onecConnection" size="18" color="grey" v-bind="attrs" v-on="on"></v-avatar>
              <v-avatar v-else-if="$store.getters.onecStates[item.id].status" size="18" color="green" v-bind="attrs" v-on="on"></v-avatar>
              <v-avatar v-else size="18" color="red" v-bind="attrs" v-on="on"></v-avatar>
            </template>
            <span v-if="item.isDeleted">Элемент удален</span>
            <span v-else-if="!item.onecConnection">Связь не настроена</span>
            <span v-else-if="$store.getters.onecStates[item.id].status">Ок</span>
            <span v-else>{{ $store.getters.onecStates[item.id].text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.updateTime="{ item }">
          <span>{{ formatUpdateTime(item.updateTime) }}</span>
        </template>
      </v-data-table>
    </v-card>

    <confirmation-dialog
      ref="confirmation"
      title="Удаление Модуля ПО"
      agree-button="Удалить"
      disagree-button="Отмена"
      @agree="deleteOurLe($event)"
    ></confirmation-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import FormatDateTime from "@/utils/time.js";

export default {
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      deletingOurLeId: "",

      tableLoading: true,
      search: "",
      showingDeleted: true,
      headers: [
        {
          text: "#",
          align: "start",
          value: "id",
        },
        {
          text: "Название",
          align: "start",
          value: "name",
        },
        {
          text: "Р/С",
          align: "start",
          value: "numbRs",
        },
        {
          text: "Связь с 1С",
          align: "center",
          value: "onecConnectionStatus",
          sortable: false,
        },
        {
          text: "Изменил",
          align: "start",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Действия",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
        exportToFile(format) {
          API.get(`our_legal_entities/reports?format=${format}`, { responseType: 'blob' })
          .then(response => {
          if (response.status === 200) {
            let contentType = '';
            let fileExtension = '';
            if (format === 'csv') {
              contentType = 'text/csv';
              fileExtension = '.csv';
            } else if (format === 'xlsx') {
              contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              fileExtension = '.xlsx';
            }
            const blob = new Blob([response.data], { type: contentType });
            const date = new Date();
            const currentDate = this.formatUpdateTime(date); 
            const filename = `Отчет Наши ЮЛ ${currentDate}${fileExtension}`.replace(/:/g, '.');
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            }
            console.log('Файл успешно загружен');
          } else {
            console.error('Ошибка загрузки файла:', response.statusText);
          }
        })
        .catch(error => {
          console.error('Ошибка загрузки файла:', error);
        });
    },
    editOurLe(ourLe) {
      if (ourLe.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Наше ЮЛ удален",
        });
      } else {
        this.$router.push("/our_legal_entities/" + ourLe.id);
      }
    },
    deleteOurLeConfirm(ourLe) {
      this.deletingOurLeId = ourLe.id;
      this.$refs.confirmation.showDialog(
        ourLe.id,
        `Вы действительно хотите удалить Наше ЮЛ <span class="highlighted">${ourLe.name}</span> ?`
      );
    },
    deleteOurLe(ourLeId) {
      API.get(`our_legal_entities/${ourLeId}/delete`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateOurLegalEntities");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    restoreOurLe(ourLe) {
      API.get(`our_legal_entities/${ourLe.id}/restore`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateOurLegalEntities");
          this.$store.dispatch("initOnecStream").then(() => {});
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  computed: {
    ourLegalEntities: function () {
      return this.$store.getters.ourLegalEntities.filter((ourLe) =>
        this.showingDeleted ? true : !ourLe.isDeleted
      );
    },
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'our_legal_entities', disabled: true},
    ]);
  },
  created() {
    this.$store.dispatch("updateOurLegalEntities").then(() => {
      this.tableLoading = false;
    });
    this.$store.dispatch("initOnecStream").then(() => {});
  },
}
</script>

<style>

</style>